import { type ForwardRefRenderFunction, forwardRef } from "react";

import { Button } from "~/ui/Button";

import { useButtonReducer } from "./useButtonReducer";

const ButtonAlphaBase: ForwardRefRenderFunction<HTMLButtonElement, unknown> = (props, ref) => {
	const { value, isLoading, isDisabled, reducerCallback } = useButtonReducer(
		props?.["reducer"],
		props?.["loading"],
		props?.["disabled"]
	);

	return (
		<>
			<Button
				ref={ref}
				disabled={isDisabled}
				loading={isLoading}
				onClick={async (e) => {
					const onClick = props?.["onClick"];
					//
					// Reducer.
					//

					await reducerCallback(value);

					//
					// Handle `onClick` just like the browser normally does, not catching errors in
					// invocation.
					//

					if (!onClick) {
						return;
					}
					if (typeof onClick !== "function") {
						console.error("onClick must be a function");
						return;
					}

					onClick(e);
				}}
				// IMPORTANT: Spread props here or `Button` will not work with RadixUI triggers!
				{...(typeof props === "object" ? props : {})}
			>
				{props?.["label"] || props?.["children"]}
			</Button>
		</>
	);
};

export const ButtonAlphaV2 = forwardRef(ButtonAlphaBase);
